export const categoryWiseMainProblem = {
    '10': [
        'Not Functioning Properly',
        'Physical Damage/Dent/Wrong',
        'Part Missing',
        'General Query',
        'Issue Not Listed here'
    ],
    '1': [
        'Errors Message',
        'Not Functioning Properly',
        'Physical Damage/Dent/Wrong',
        'Part Missing',
        'General Query',
        'Issue Not Listed here'
    ],
    '29': [
        'Not Functioning Properly',
        'Physical Damage/Dent/Wrong',
        'Part Missing',
        'General Query',
        'Issue Not Listed here'
    ],
    '30': [
        'Not Functioning Properly',
        'Physical Damage/Dent/Wrong',
        'Part Missing',
        'General Query',
        'Issue Not Listed here'
    ],
    '9': [
        'Not Functioning Properly',
        'Physical Damage/Dent/Wrong',
        'Part Missing',
        'General Query',
        'Issue Not Listed here',
    ],
    '33': [
        'Physical Damage/Dent/Wrong'
    ],
    '36': [
        'Features Related',
        'Firmware Related',
        'Physical Dent/Wrong',
        'Part Missing',
        'General Query',
        'Manufacturing Related',
        'App Related',
        'Issue Not Listed here',
    ],
    '14': [
        'Features Related',
        'Firmware Related',
        'Physical Dent/Wrong',
        'Part Missing',
        'General Query',
        'Manufacturing Related',
        'App Related',
        'Issue Not Listed here',
    ],
    '8': [
        'Errors Issue',
        'Not Functioning Properly',
        'Part Missing',
        'Physical Damage/Dent/Wrong',
        'General Query',
        'Issue Not Listed here',
        'Accuracy Issue',
    ]
};
export const devSubProblemList = {
    '10': {
        'Not Functioning Properly': [
            'Z Crank Not Working',
            'Abnormal Noise',
            'Belt Getting Removed',
            'Not getting Started',
            'Display Issue',
            'Others'
        ],
        'Physical Damage/Dent/Wrong': [
            'Z Crank',
            'Paddle Damage',
            'Dent on body',
            'Broken Welding',
            'Old used Product',
            'Wrong Product Received',
            'Cloth belt'
        ],
        'Part Missing': [
            'Nut & bolt',
            'Paddle',
            'Back Seat',
            'Others'
        ],
        'General Query': [
            'User Manual Required',
            'features Query'
        ],
        'Issue Not Listed here': [
            'Others'
        ],
    },
    '1': {
        'Errors Message': [
            'E1',
            'E2',
            'E3', 'E4', 888, 'Others'
        ],
        'Not Functioning Properly': [
            'Accuracy Issue',
            'Not Getting Started',
            'Battery Backup issue',
            'On/off button not working',
            'No Readings',
            'Left button not working',
            'right button not working',
            'Abnormal Noise',
            'Display Not working',
            'Cuff Issue'
        ],
        'Physical Damage/Dent/Wrong': [
            'Loose Attachments',
            'Old Used Product',
            'Scratches/Dent on body',
            'Display Broken/Damage',
            'Wrong Product Received',
            'Others'
        ],
        'General Query': [
            'User Manual Required', 'features Query', 'USB Cable Functionality'
        ],
        'Part Missing': ['Missing Cuff', 'Missing Batteries', 'Missing data cable'],
        'Issue Not Listed here': [
            'Others'
        ],
    },
    '29': {
        'Not Functioning Properly': [
            'Not Getting Started',
            'Battery Backup issue',
            'Unable to charge',
            'Abnormal Noise'
        ],
        'Physical Damage/Dent/Wrong': [
            'Wrong Product Received',
            'Wrong Color Received',
            'Damage Product',
            'Old Used Product',
            'Brush Head Missing'
        ],
        'Part Missing': [
            'Charging Cable missing',
            'Brush Head Missing',
            'Others'
        ],
        'General Query': [
            'Extra Brush head Required',
            'User Manual Required',
            'Features Query'
        ],
        'Issue Not Listed here': ['Others']
    },
    '30': {
        'Not Functioning Properly': [
            'Not Getting Started',
            'Battery Backup issue',
            'Unable to charge',
            'Abnormal Noise'
        ],
        'Physical Damage/Dent/Wrong': [
            'Wrong Product Received',
            'Wrong Color Received',
            'Damaged Product',
            'Old Used Product',
            'Brush Head Missing'
        ],
        'Part Missing': [
            'Charging Cable missing',
            'Brush Head Missing',
            'Others'
        ],
        'General Query': [
            'Extra Brush head Required',
            'User Manual Required',
            'Features Query'
        ],
        'Issue Not Listed here': ['Others']
    },
    '9': {
        'Not Functioning Properly': [
            'Automatic Restart',
            'Not Getting Started',
            'Battery Backup issue',
            'Unable to charge',
            'Abnormal Noise',
            'Heating Issue',
            'Loose Attachment',
            'Low Vibration Strength',
            'Motor not working'
        ],
        'Physical Damage/Dent/Wrong': [
            'Wrong Product Received',
            'Wrong Color Received',
            'Damage Product',
            'Old Used Product',
            'Others',
        ],
        'Part Missing': [
            'Charging Cable missing',
            'Missing Attachement',
            'Others'
        ],
        'General Query': [
            'User Manual Required',
            'features Query'
        ],
        'Issue Not Listed here': ['Others'],
    },
    '33': {
        'Physical Damage/Dent/Wrong': ['Damage Product Received']
    },
    '36': {
        'Physical Dent/Wrong': [
            'Wrong Prodcuct Received',
            'Wrong Color Received',
            'Old Used Product',
            'Others'
        ],
        'Features Related': [
            'BP',
            'Heart Rate',
            'Step rate',
            'SPO2',
            'ECG',
            'Sleep Cycle',
            'Stress/mood',
            'Sports Mode not working',
            'Raise to wake',
            'Call Feature/Notifications issue'
        ],
        'Firmware Related': [
            'Others',
            'Automatic Restart',
            'Display Lagging',
            'Blank Screen'
        ],
        'Part Missing': [
            'Charging Cable missing',
            'Others'
        ],
        'General Query': [
            'User Manual Required',
            'features Query'
        ],
        'Manufacturing Related': [
            'Body Damaged/Scracthes',
            'Touch Not working',
            'Lining on display',
            'Tilt Screen',
            'Speaker Not Working',
            'Crown/side button issue',
            'Unable to charge',
            'Battery Backup Issue',
            'Dead watch',
            'Strap Size or Strap Issue',
            'Vibration not working',
            'Others'
        ],
        'App Related': [
            'Unable to connect',
            'Bluetooth Connected ( Data not Reflecting)',
            'App features not working',
            'Unable to login',
            'Bluetooth Connected ( Data not Reflecting)',
        ],
        'Issue Not Listed here': ['Others']
    },
    '14': {
        'Physical Dent/Wrong': [
            'Wrong Prodcuct Received',
            'Wrong Color Received',
            'Old Used Product',
            'Others'
        ],
        'Features Related': [
            'BP',
            'Heart Rate',
            'Step rate',
            'SPO2',
            'ECG',
            'Sleep Cycle',
            'Stress/mood',
            'Sports Mode not working',
            'Raise to wake',
            'Call Feature/Notifications issue'
        ],
        'Firmware Related': [
            'Others',
            'Automatic Restart',
            'Display Lagging',
            'Blank Screen'
        ],
        'Part Missing': [
            'Charging Cable missing',
            'Others'
        ],
        'General Query': [
            'User Manual Required',
            'features Query'
        ],
        'Manufacturing Related': [
            'Body Damaged/Scracthes',
            'Touch Not working',
            'Lining on display',
            'Tilt Screen',
            'Speaker Not Working',
            'Crown/side button issue',
            'Unable to charge',
            'Battery Backup Issue',
            'Dead watch',
            'Strap Size or Strap Issue',
            'Vibration not working',
            'Others'
        ],
        'App Related': [
            'Unable to connect',
            'Bluetooth Connected ( Data not Reflecting)',
            'App features not working',
            'Unable to login',
            'Bluetooth Connected ( Data not Reflecting)',
        ],
        'Issue Not Listed here': ['Others']
    },
    '8': {
        'Errors Issue': [
            'OL Issue',
            'LO issue'
        ],
        'Not Functioning Properly': [
            'Bluetooth Connected ( Paremeters not Reflecting)',
            'Battery Backup issue',
            'Unable to Connect with App',
            'Unable to view all parameters',
            'Not Getting Started',
            'Restet Button Not working',
            'Unable to add profile',
            'Others'
        ],
        'Part Missing': [
            'Missing Batteries'
        ],
        'Physical Damage/Dent/Wrong': [
            'Borken/Damage',
            'Old Used Product',
            'Display Issue',
            'Wrong Product Received',
            'Wrong color Received'
        ],
        'General Query': [
            'LB and KG Query',
            'User Manual Required',
            'Features Query',
            'how to reset',
        ],
        'Issue Not Listed here': ['Others'],
        'Accuracy Issue': [
            'Weight Variation',
            'No Readings',
            'Wrong BMI'
        ]
    }
};
export const prodCategoryWiseMainProblem = {
    '1': [
        'Not Functioning Properly',
        'Physical Damage/Dent/Wrong',
        'Part Missing',
        'General Query',
        'Issue Not Listed here'
    ],
    '20': [
        'Not Functioning Properly',
        'Physical Damage/Dent/Wrong',
        'Part Missing',
        'General Query',
        'Issue Not Listed here'
    ],
    '24': [
        'Not Functioning Properly',
        'Physical Damage/Dent/Wrong',
        'Part Missing',
        'General Query',
        'Issue Not Listed here'
    ],
    '2': [
        'Errors Message',
        'Not Functioning Properly',
        'Physical Damage/Dent/Wrong',
        'Part Missing',
        'General Query',
        'Issue Not Listed here'
    ],
    '23': [
        'Not Functioning Properly',
        'Physical Damage/Dent/Wrong',
        'Part Missing',
        'General Query',
        'Issue Not Listed here'
    ],
    '9': [
        'Not Functioning Properly',
        'Physical Damage/Dent/Wrong',
        'Part Missing',
        'General Query',
        'Issue Not Listed here'
    ],
    '12': [
        'Not Functioning Properly',
        'Physical Damage/Dent/Wrong',
        'Part Missing',
        'General Query',
        'Issue Not Listed here',
    ],
    '17': [
        'Physical Damage/Dent/Wrong'
    ],
    '19': [
        'Features Related',
        'Firmware Related',
        'Physical Dent/Wrong',
        'Part Missing',
        'General Query',
        'Manufacturing Related',
        'App Related',
        'Issue Not Listed here',
    ],
    '28': [
        'Errors Issue',
        'Not Functioning Properly',
        'Part Missing',
        'Physical Damage/Dent/Wrong',
        'General Query',
        'Issue Not Listed here',
        'Accuracy Issue',
    ]
};
export const prodSubProblemList = {
    '1': {
        'Not Functioning Properly': [
            'Z Crank Not Working',
            'Abnormal Noise',
            'Belt Getting Removed',
            'Not getting Started',
            'Display Issue',
            'Others'
        ],
        'Physical Damage/Dent/Wrong': [
            'Z Crank',
            'Paddle Damage',
            'Dent on body',
            'Broken Welding',
            'Old used Product',
            'Wrong Product Received',
            'Cloth belt'
        ],
        'Part Missing': [
            'Nut & bolt',
            'Paddle',
            'Back Seat',
            'Others'
        ],
        'General Query': [
            'User Manual Required',
            'features Query'
        ],
        'Issue Not Listed here': [
            'Others'
        ],
    },
    '20': {
        'Not Functioning Properly': [
            'Z Crank Not Working',
            'Abnormal Noise',
            'Belt Getting Removed',
            'Not getting Started',
            'Display Issue',
            'Others'
        ],
        'Physical Damage/Dent/Wrong': [
            'Z Crank',
            'Paddle Damage',
            'Dent on body',
            'Broken Welding',
            'Old used Product',
            'Wrong Product Received',
            'Cloth belt'
        ],
        'Part Missing': [
            'Nut & bolt',
            'Paddle',
            'Back Seat',
            'Others'
        ],
        'General Query': [
            'User Manual Required',
            'features Query'
        ],
        'Issue Not Listed here': [
            'Others'
        ],
    },
    '24': {
        'Not Functioning Properly': [
            'Z Crank Not Working',
            'Abnormal Noise',
            'Belt Getting Removed',
            'Not getting Started',
            'Display Issue',
            'Others'
        ],
        'Physical Damage/Dent/Wrong': [
            'Z Crank',
            'Paddle Damage',
            'Dent on body',
            'Broken Welding',
            'Old used Product',
            'Wrong Product Received',
            'Cloth belt'
        ],
        'Part Missing': [
            'Nut & bolt',
            'Paddle',
            'Back Seat',
            'Others'
        ],
        'General Query': [
            'User Manual Required',
            'features Query'
        ],
        'Issue Not Listed here': [
            'Others'
        ],
    },
    '2': {
        'Errors Message': [
            'E1',
            'E2',
            'E3', 'E4', 888, 'Others'
        ],
        'Not Functioning Properly': [
            'Accuracy Issue',
            'Not Getting Started',
            'Battery Backup issue',
            'On/off button not working',
            'No Readings',
            'Left button not working',
            'right button not working',
            'Abnormal Noise',
            'Display Not working',
            'Cuff Issue'
        ],
        'Physical Damage/Dent/Wrong': [
            'Loose Attachments',
            'Old Used Product',
            'Scratches/Dent on body',
            'Display Broken/Damage',
            'Wrong Product Received',
            'Others'
        ],
        'General Query': [
            'User Manual Required', 'features Query', 'USB Cable Functionality'
        ],
        'Part Missing': ['Missing Cuff', 'Missing Batteries', 'Missing data cable'],
        'Issue Not Listed here': [
            'Others'
        ],
    },
    '23': {
        'Not Functioning Properly': [
            'Not Getting Started',
            'Battery Backup issue',
            'Unable to charge',
            'Abnormal Noise'
        ],
        'Physical Damage/Dent/Wrong': [
            'Wrong Product Received',
            'Wrong Color Received',
            'Damage Product',
            'Old Used Product',
            'Brush Head Missing'
        ],
        'Part Missing': [
            'Charging Cable missing',
            'Brush Head Missing',
            'Others'
        ],
        'General Query': [
            'Extra Brush head Required',
            'User Manual Required',
            'Features Query'
        ],
        'Issue Not Listed here': ['Others']
    },
    '9': {
        'Not Functioning Properly': [
            'Not Getting Started',
            'Battery Backup issue',
            'Unable to charge',
            'Abnormal Noise'
        ],
        'Physical Damage/Dent/Wrong': [
            'Wrong Product Received',
            'Wrong Color Received',
            'Damaged Product',
            'Old Used Product',
            'Brush Head Missing'
        ],
        'Part Missing': [
            'Charging Cable missing',
            'Brush Head Missing',
            'Others'
        ],
        'General Query': [
            'Extra Brush head Required',
            'User Manual Required',
            'Features Query'
        ],
        'Issue Not Listed here': ['Others']
    },
    '12': {
        'Not Functioning Properly': [
            'Automatic Restart',
            'Not Getting Started',
            'Battery Backup issue',
            'Unable to charge',
            'Abnormal Noise',
            'Heating Issue',
            'Loose Attachment',
            'Low Vibration Strength',
            'Motor not working'
        ],
        'Physical Damage/Dent/Wrong': [
            'Wrong Product Received',
            'Wrong Color Received',
            'Damage Product',
            'Old Used Product',
            'Others',
        ],
        'Part Missing': [
            'Charging Cable missing',
            'Missing Attachement',
            'Others'
        ],
        'General Query': [
            'User Manual Required',
            'features Query'
        ],
        'Issue Not Listed here': ['Others'],
    },
    '17': {
        'Physical Damage/Dent/Wrong': ['Damage Product Received']
    },
    '19': {
        'Physical Dent/Wrong': [
            'Wrong Prodcuct Received',
            'Wrong Color Received',
            'Old Used Product',
            'Others'
        ],
        'Features Related': [
            'BP',
            'Heart Rate',
            'Step rate',
            'SPO2',
            'ECG',
            'Sleep Cycle',
            'Stress/mood',
            'Sports Mode not working',
            'Raise to wake',
            'Call Feature/Notifications issue'
        ],
        'Firmware Related': [
            'Others',
            'Automatic Restart',
            'Display Lagging',
            'Blank Screen'
        ],
        'Part Missing': [
            'Charging Cable missing',
            'Others'
        ],
        'General Query': [
            'User Manual Required',
            'features Query'
        ],
        'Manufacturing Related': [
            'Body Damaged/Scracthes',
            'Touch Not working',
            'Lining on display',
            'Tilt Screen',
            'Speaker Not Working',
            'Crown/side button issue',
            'Unable to charge',
            'Battery Backup Issue',
            'Dead watch',
            'Strap Size or Strap Issue',
            'Vibration not working',
            'Others'
        ],
        'App Related': [
            'Unable to connect',
            'Bluetooth Connected ( Data not Reflecting)',
            'App features not working',
            'Unable to login',
            'Bluetooth Connected ( Data not Reflecting)',
        ],
        'Issue Not Listed here': ['Others']
    },
    '28': {
        'Errors Issue': [
            'OL Issue',
            'LO issue'
        ],
        'Not Functioning Properly': [
            'Bluetooth Connected ( Paremeters not Reflecting)',
            'Battery Backup issue',
            'Unable to Connect with App',
            'Unable to view all parameters',
            'Not Getting Started',
            'Restet Button Not working',
            'Unable to add profile',
            'Others'
        ],
        'Part Missing': [
            'Missing Batteries'
        ],
        'Physical Damage/Dent/Wrong': [
            'Borken/Damage',
            'Old Used Product',
            'Display Issue',
            'Wrong Product Received',
            'Wrong color Received'
        ],
        'General Query': [
            'LB and KG Query',
            'User Manual Required',
            'Features Query',
            'how to reset',
        ],
        'Issue Not Listed here': ['Others'],
        'Accuracy Issue': [
            'Weight Variation',
            'No Readings',
            'Wrong BMI'
        ]
    }
};
export const prodCategoryWiseComms = {
    '2': {
        'Not Functioning Properly': {
            'Not Getting Started': `Please plug your phone into the charger to verify that the plug is working fine. <br/>  Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`
        }
    },
    '23': {
        'Not Functioning Properly': {
            'Not Getting Started': `Please plug your phone into the charger to verify that the plug is working fine.<br/>  Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Unable to charge': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`
        }
    },
    '9': {
        'Not Functioning Properly': {
            'Not Getting Started': `Please plug your phone into the charger to verify that the plug is working fine.<br/>  Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Unable to charge': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`
        }
    },
    '12': {
        'Not Functioning Properly': {
            'Automatic Restart': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Not Getting Started': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Unable to charge': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`
        }
    },
    '19': {
        'Features Related': {
            'BP': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Heart Rate': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Step rate': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'SPO2': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'ECG': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Sleep Cycle': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Stress/mood': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Sports Mode not working': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Raise to wake': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Call Feature/Notifications issue': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Others': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Automatic Restart': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Display Lagging': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Blank Screen': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
        },
        'Manufacturing Related': {
            'Speaker Not Working': `Please share the video while following these instructions: <br/>
                            Please keep the phone and the watch side by side.<br/>
                            Dial 198 from your watch and Turn On the speaker on the watch.<br/>
                            Please play any music on the watch and increase the watch volume.<br/>
                            Please share the video without any cuts or pauses.`,
            'Unable to charge': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Battery Backup Issue': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Dead watch': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`
        }
    },
    '28': {
        'Not Functioning Properly': {
            'Not Getting Started': `Please share the video while following these instructions: <br/>
                            1. Please create a video while placing new seal-packed batteries. <br/>
                            2. Put the weighing scale on a flat surface and stand on it with bare feet. <br/>
                            3. Please share the video without any cuts or pauses.`
        },
        'Accuracy Issue': {
            'Weight Variation': `Please share the video while following these instructions: <br/>
                            1. Please create a video while placing new seal-packed batteries. <br/>
                            2. Put the weighing scale on a flat surface and stand on it with bare feet. <br/>
                            3. Please share the video without any cuts or pauses.`,
            'No Readings': `Please share the video while following these instructions: <br/>
                            1. Please create a video while placing new seal-packed batteries. <br/>
                            2. Put the weighing scale on a flat surface and stand on it with bare feet. <br/>
                            3. Please share the video without any cuts or pauses.`,
            'Wrong BMI': `Please share the video while following these instructions: <br/>
                            1. Please create a video while placing new seal-packed batteries. <br/>
                            2. Put the weighing scale on a flat surface and stand on it with bare feet. <br/>
                            3. Please share the video without any cuts or pauses.`
        }
    }

}
export const categoryWiseComms = {
    '1': {
        'Not Functioning Properly': {
            'Not Getting Started': `Please plug your phone into the charger to verify that the plug is working fine. <br/>  Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`
        }
    },
    '29': {
        'Not Functioning Properly': {
            'Not Getting Started': `Please plug your phone into the charger to verify that the plug is working fine.<br/>  Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Unable to charge': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`
        }
    },
    '9': {
        'Not Functioning Properly': {
            'Automatic Restart': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Not Getting Started': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Unable to charge': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`
        }
    },
    '36': {
        'Features Related': {
            'BP': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Heart Rate': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Step rate': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'SPO2': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'ECG': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Sleep Cycle': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Stress/mood': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Sports Mode not working': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Raise to wake': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Call Feature/Notifications issue': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Others': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Automatic Restart': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Display Lagging': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Blank Screen': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
        },
        'Manufacturing Related': {
            'Speaker Not Working': `Please share the video while following these instructions: <br/>
                Please keep the phone and the watch side by side.<br/>
                Dial 198 from your watch and Turn On the speaker on the watch.<br/>
                Please play any music on the watch and increase the watch volume.<br/>
                Please share the video without any cuts or pauses.`,
            'Unable to charge': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Battery Backup Issue': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Dead watch': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`
        }
    },
    '14': {
        'Features Related': {
            'BP': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Heart Rate': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Step rate': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'SPO2': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'ECG': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Sleep Cycle': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Stress/mood': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Sports Mode not working': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Raise to wake': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Call Feature/Notifications issue': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Others': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Automatic Restart': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Display Lagging': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
            'Blank Screen': 'Before proceeding with this request, You are suggested to reset your smartwatch and update/re-install your Smartwatch Application on your mobile phone.',
        },
        'Manufacturing Related': {
            'Speaker Not Working': `Please share the video while following these instructions: <br/>
                Please keep the phone and the watch side by side.<br/>
                Dial 198 from your watch and Turn On the speaker on the watch.<br/>
                Please play any music on the watch and increase the watch volume.<br/>
                Please share the video without any cuts or pauses.`,
            'Unable to charge': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Battery Backup Issue': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`,
            'Dead watch': `Please plug your phone into the charger to verify that the plug is working fine. <br/> Then plug your watch into the charger and try to start it by pressing the Power button. After removing the charger, try to start it by pressing the Power button.`
        }
    },
    '8': {
        'Not Functioning Properly': {
            'Not Getting Started': `Please share the video while following these instructions: <br/>
                1. Please create a video while placing new seal-packed batteries. <br/>
                2. Put the weighing scale on a flat surface and stand on it with bare feet. <br/>
                3. Please share the video without any cuts or pauses.`
        },
        'Accuracy Issue': {
            'Weight Variation': `Please share the video while following these instructions: <br/>
                1. Please create a video while placing new seal-packed batteries. <br/>
                2. Put the weighing scale on a flat surface and stand on it with bare feet. <br/>
                3. Please share the video without any cuts or pauses.`,
            'No Readings': `Please share the video while following these instructions: <br/>
                1. Please create a video while placing new seal-packed batteries. <br/>
                2. Put the weighing scale on a flat surface and stand on it with bare feet. <br/>
                3. Please share the video without any cuts or pauses.`,
            'Wrong BMI': `Please share the video while following these instructions: <br/>
                1. Please create a video while placing new seal-packed batteries. <br/>
                2. Put the weighing scale on a flat surface and stand on it with bare feet. <br/>
                3. Please share the video without any cuts or pauses.`
        }
    }

}
export const deliveryRelatedProblemList = [
    'Asking for Delivery boy Number',
    'Empty Box Received',
    'In Transit-Outside ETA',
    'In Transit-Within ETA',
    'Open/Tampered Box Delivery Received',
    'Order in RTO',
    'Order Marked Delivered- Not Received',
    'Order Not Dispatched',
    'Others',
]
export const categoryList = [
    {
        "custom_layout_update_file": "",
        "is_anchor": "1",
        "display_mode": "PRODUCTS",
        "custom_layout_update": "",
        "children_count": "static",
        "extra_category_info": [],
        "custom_design": "",
        "description": "<p>Air Bike- <em>Exercise Cycle for Home Gym</em></p>",
        "sub_categories_list": [],
        "all_children": "",
        "meta_keywords": "",
        "isActive": "0",
        "path_in_store": "",
        "path": "static",
        "sync_to_facebook_catalog": "1",
        "children": "",
        "filter_price_range": "",
        "page_layout": "",
        "available_sort_by": "",
        "imageUrl": "318-x-177_3_1.jpg",
        "id": "18",
        "special_category": "",
        "url_path": "air-bikes",
        "meta_title": "",
        "level": "static",
        "landing_page": "",
        "custom_apply_to_products": "0",
        "custom_design_to": "",
        "urlKey": "air-bikes",
        "meta_description": "",
        "custom_design_from": "",
        "name": "Air Bikes",
        "includeInMenu": "0",
        "default_sort_by": "",
        "position": "static",
        "custom_use_parent_settings": "0"
    },
    {
        "custom_layout_update_file": "",
        "is_anchor": "1",
        "display_mode": "PRODUCTS_AND_PAGE",
        "custom_layout_update": "",
        "children_count": "static",
        "extra_category_info": [
            {
                "id": 5,
                "categoryId": "19",
                "desktopImage": "https://img.beatxp.com/prod/categories/banner/treadmil%20_%20spinbike%20banner%20desktop.webp",
                "mobileImage": "https://img.beatxp.com/prod/categories/banner/health%20_%20personal%20care%20banner%20mobile%20copy.webp",
                "blogInfo": "544,898,62",
                "categoryThumbnail": "https://img.beatxp.com/prod/category/thumbnail/%2FGym%20Accessories.webp"
            }
        ],
        "custom_design": "",
        "description": "<p>Air Bikes, Dumbbells, Protein Shaker &amp; Yoga Mats</p>",
        "sub_categories_list": [],
        "all_children": "",
        "meta_keywords": "",
        "isActive": "1",
        "path_in_store": "",
        "path": "static",
        "sync_to_facebook_catalog": "1",
        "children": "",
        "filter_price_range": "",
        "page_layout": "",
        "available_sort_by": "price",
        "imageUrl": "/pub/media/catalog/category/Categories_gym.jpg",
        "id": "19",
        "special_category": "",
        "url_path": "gym-accessories",
        "meta_title": "",
        "level": "static",
        "landing_page": "",
        "custom_apply_to_products": "0",
        "custom_design_to": "",
        "urlKey": "gym-accessories",
        "meta_description": "",
        "custom_design_from": "",
        "name": "Gym Accessories",
        "includeInMenu": "1",
        "default_sort_by": "price",
        "position": "static",
        "custom_use_parent_settings": "0"
    },
    {
        "custom_layout_update_file": "",
        "is_anchor": "1",
        "display_mode": "PRODUCTS",
        "custom_layout_update": "",
        "children_count": "static",
        "extra_category_info": [],
        "custom_design": "",
        "description": "<p>Orthopedic- <em>Medical Braces &amp; Supports</em></p>",
        "sub_categories_list": [],
        "all_children": "",
        "meta_keywords": "",
        "isActive": "1",
        "path_in_store": "",
        "path": "static",
        "sync_to_facebook_catalog": "1",
        "children": "",
        "filter_price_range": "",
        "page_layout": "",
        "available_sort_by": "",
        "imageUrl": "",
        "id": "21",
        "special_category": "",
        "url_path": "ortho-supports",
        "meta_title": "",
        "level": "static",
        "landing_page": "",
        "custom_apply_to_products": "0",
        "custom_design_to": "",
        "urlKey": "ortho-supports",
        "meta_description": "",
        "custom_design_from": "",
        "name": "Orthopedic Equipment",
        "includeInMenu": "1",
        "default_sort_by": "",
        "position": "static",
        "custom_use_parent_settings": "0"
    },
    {
        "custom_layout_update_file": "",
        "is_anchor": "1",
        "display_mode": "PRODUCTS",
        "custom_layout_update": "",
        "children_count": "static",
        "extra_category_info": [],
        "custom_design": "",
        "description": "<p>Yoga Mat - <em>the key to flexibity</em></p>",
        "sub_categories_list": [],
        "all_children": "",
        "meta_keywords": "",
        "isActive": "0",
        "path_in_store": "",
        "path": "static",
        "sync_to_facebook_catalog": "0",
        "children": "",
        "filter_price_range": "",
        "page_layout": "",
        "available_sort_by": "",
        "imageUrl": "/pub/media/catalog/category/Categories_yoga_mat.jpg",
        "id": "22",
        "special_category": "",
        "url_path": "yoga",
        "meta_title": "",
        "level": "static",
        "landing_page": "",
        "custom_apply_to_products": "0",
        "custom_design_to": "",
        "urlKey": "yoga",
        "meta_description": "",
        "custom_design_from": "",
        "name": "Yoga Mat",
        "includeInMenu": "0",
        "default_sort_by": "",
        "position": "static",
        "custom_use_parent_settings": "0"
    },
    {
        "custom_layout_update_file": "",
        "is_anchor": "1",
        "display_mode": "PRODUCTS",
        "custom_layout_update": "",
        "children_count": "static",
        "extra_category_info": [
            {
                "id": 4,
                "categoryId": "23",
                "desktopImage": "https://img.beatxp.com/prod/categories/banner/health%20_%20personal%20care%20banner%20desktop.webp",
                "mobileImage": "https://img.beatxp.com/prod/categories/banner/health%20_%20personal%20care%20banner%20mobile%20copy.webp",
                "blogInfo": "964,64,66",
                "categoryThumbnail": "https://img.beatxp.com/prod/category/thumbnail/%2FHealth%20%26%20Personal%20Care.webp"
            }
        ],
        "custom_design": "",
        "description": "<p>BP Monitor, Digital Weighing Scale &amp; BMI</p>",
        "sub_categories_list": [],
        "all_children": "",
        "meta_keywords": "weighing scales, bp monitor, electric toothbrush, best bluetooth weighing scale, rechargeable electric toothbrush, smart weighing machine, bluetooth kitchen scale",
        "isActive": "1",
        "path_in_store": "",
        "path": "static",
        "sync_to_facebook_catalog": "1",
        "children": "",
        "filter_price_range": "",
        "page_layout": "",
        "available_sort_by": "",
        "imageUrl": "/pub/media/catalog/category/Categories_wellness.jpg",
        "id": "23",
        "special_category": "",
        "url_path": "health-personal-care",
        "meta_title": "Order Digital Weighing Scales, Electric Toothbrush, BP Monitors & More",
        "level": "static",
        "landing_page": "",
        "custom_apply_to_products": "0",
        "custom_design_to": "",
        "urlKey": "health-personal-care",
        "meta_description": "Buy premium quality electric toothbrushes, digital and smart bluetooth weighing scale, bp monitors and more. Checkout now!",
        "custom_design_from": "",
        "name": "Health & Personal Care",
        "includeInMenu": "1",
        "default_sort_by": "",
        "position": "static",
        "custom_use_parent_settings": "0"
    },
    {
        "custom_layout_update_file": "",
        "is_anchor": "1",
        "display_mode": "PRODUCTS",
        "custom_layout_update": "",
        "children_count": "static",
        "extra_category_info": [
            {
                "id": 2,
                "categoryId": "24",
                "desktopImage": "https://img.beatxp.com/prod/blogInfo/massager%20banner%20desktop_1.webp",
                "mobileImage": "https://img.beatxp.com/prod/blogInfo/massager%20banner%20mobile_2.webp",
                "blogInfo": "1228,692,503",
                "categoryThumbnail": "https://img.beatxp.com/prod/category/thumbnail/%2FBody%20Massagers.webp"
            }
        ],
        "custom_design": "",
        "description": "<p>Massage Gun, Leg, Neck &amp; Shoulder Massager</p>",
        "sub_categories_list": [],
        "all_children": "",
        "meta_keywords": "body massager, massage gun, best massage gun, best body massagers, Flash Deep Tissue Massage Gun, Blaze Elite Deep Tissue Handheld Massager, PowerHeal Go Cushion Kneading Massager, Bolt Go Deep Tissue Massage Gun, Stream Pro Cordless Full Body Massager, ArcHeal Foot Sole Kneading Massager, DeepHeal Massager Pillow",
        "isActive": "1",
        "path_in_store": "",
        "path": "static",
        "sync_to_facebook_catalog": "1",
        "children": "",
        "filter_price_range": "",
        "page_layout": "",
        "available_sort_by": "",
        "imageUrl": "/pub/media/catalog/category/sd_1_.jpg",
        "id": "24",
        "special_category": "",
        "url_path": "body-massagers",
        "meta_title": "Buy Best Body Massagers/ Massage Gun for Sore Muscles & Recovery",
        "level": "static",
        "landing_page": "",
        "custom_apply_to_products": "0",
        "custom_design_to": "",
        "urlKey": "body-massagers",
        "meta_description": "beatXP Body Massagers - Say goodbye to muscle fatigue and soreness with the best, premium massage guns & handheld massagers that help you recover faster. Shop now!",
        "custom_design_from": "",
        "name": "Body Massagers",
        "includeInMenu": "1",
        "default_sort_by": "",
        "position": "static",
        "custom_use_parent_settings": "0"
    },
    {
        "custom_layout_update_file": "",
        "is_anchor": "0",
        "display_mode": "PRODUCTS",
        "custom_layout_update": "",
        "children_count": "static",
        "extra_category_info": [],
        "custom_design": "",
        "description": "",
        "sub_categories_list": [],
        "all_children": "",
        "meta_keywords": "",
        "isActive": "0",
        "path_in_store": "",
        "path": "static",
        "sync_to_facebook_catalog": "1",
        "children": "",
        "filter_price_range": "",
        "page_layout": "",
        "available_sort_by": "",
        "imageUrl": "",
        "id": "25",
        "special_category": "",
        "url_path": "exercise-cycle",
        "meta_title": "",
        "level": "static",
        "landing_page": "",
        "custom_apply_to_products": "0",
        "custom_design_to": "",
        "urlKey": "exercise-cycle",
        "meta_description": "",
        "custom_design_from": "",
        "name": "Exercise cycle",
        "includeInMenu": "0",
        "default_sort_by": "",
        "position": "static",
        "custom_use_parent_settings": "1"
    },
    {
        "custom_layout_update_file": "",
        "is_anchor": "1",
        "display_mode": "PRODUCTS",
        "custom_layout_update": "",
        "children_count": "static",
        "extra_category_info": [],
        "custom_design": "",
        "description": "",
        "sub_categories_list": [],
        "all_children": "",
        "meta_keywords": "",
        "isActive": "0",
        "path_in_store": "",
        "path": "static",
        "sync_to_facebook_catalog": "1",
        "children": "",
        "filter_price_range": "",
        "page_layout": "",
        "available_sort_by": "",
        "imageUrl": "",
        "id": "27",
        "special_category": "",
        "url_path": "bmi",
        "meta_title": "",
        "level": "static",
        "landing_page": "",
        "custom_apply_to_products": "0",
        "custom_design_to": "",
        "urlKey": "bmi",
        "meta_description": "",
        "custom_design_from": "",
        "name": "BMI",
        "includeInMenu": "0",
        "default_sort_by": "",
        "position": "static",
        "custom_use_parent_settings": "0"
    },
    {
        "custom_layout_update_file": "",
        "is_anchor": "1",
        "display_mode": "PRODUCTS",
        "custom_layout_update": "",
        "children_count": "static",
        "extra_category_info": [],
        "custom_design": "",
        "description": "",
        "sub_categories_list": [],
        "all_children": "",
        "meta_keywords": "",
        "isActive": "0",
        "path_in_store": "",
        "path": "static",
        "sync_to_facebook_catalog": "1",
        "children": "",
        "filter_price_range": "",
        "page_layout": "",
        "available_sort_by": "",
        "imageUrl": "",
        "id": "32",
        "special_category": "",
        "url_path": "airbike-6k",
        "meta_title": "",
        "level": "static",
        "landing_page": "",
        "custom_apply_to_products": "0",
        "custom_design_to": "",
        "urlKey": "airbike-6k",
        "meta_description": "",
        "custom_design_from": "",
        "name": "Airbikes-6K",
        "includeInMenu": "0",
        "default_sort_by": "",
        "position": "static",
        "custom_use_parent_settings": "0"
    },
    {
        "custom_layout_update_file": "",
        "is_anchor": "1",
        "display_mode": "PRODUCTS",
        "custom_layout_update": "",
        "children_count": "static",
        "extra_category_info": [],
        "custom_design": "",
        "description": "",
        "sub_categories_list": [],
        "all_children": "",
        "meta_keywords": "",
        "isActive": "0",
        "path_in_store": "",
        "path": "static",
        "sync_to_facebook_catalog": "1",
        "children": "",
        "filter_price_range": "",
        "page_layout": "",
        "available_sort_by": "",
        "imageUrl": "",
        "id": "35",
        "special_category": "",
        "url_path": "products",
        "meta_title": "",
        "level": "static",
        "landing_page": "",
        "custom_apply_to_products": "0",
        "custom_design_to": "",
        "urlKey": "products",
        "meta_description": "",
        "custom_design_from": "",
        "name": "Top Products",
        "includeInMenu": "0",
        "default_sort_by": "",
        "position": "static",
        "custom_use_parent_settings": "0"
    },
    // {
    //     "custom_layout_update_file": "",
    //     "is_anchor": "1",
    //     "display_mode": "PRODUCTS",
    //     "custom_layout_update": "",
    //     "children_count": "static",
    //     "extra_category_info": [
    //         {
    //             "id": 1,
    //             "categoryId": "37",
    //             "desktopImage": "https://img.beatxp.com/prod/blogInfo/CategoryPage_Smartwatch_Carry_Mobile.jpg",
    //             "mobileImage": "https://img.beatxp.com/prod/blogInfo/CategoryPage_Smartwatch_Carry_Mobile.jpg",
    //             "blogInfo": "793,1119,1082",
    //             "categoryThumbnail": "https://img.beatxp.com/prod/category/thumbnail/%2FSmart%20watches.webp"
    //         }
    //     ],
    //     "custom_design": "",
    //     "description": "",
    //     "sub_categories_list": [
    //         {
    //             "mobileImage": "www.image.beatxp.com",
    //             "subCatId": 1,
    //             "parentCatId": 37,
    //             "description": "<h2><strong>Best Bluetooth Amoled Smart watches Under Rs 3000</strong></h2> <h3><strong>Experience the brilliance of Amoled displays</strong></h3> <p><span>Amoled displays are known for their vibrant and vivid colors, sharp visuals, and enhanced visibility, even in bright sunlight. This makes them the perfect choice for smartwatches, as you want to be able to see your watch clearly no matter where you are or what you're doing.</span></p> <h3><strong>Budget-friendly options, we offer a collection of smartwatches under Rs 3000</strong></h3> <p><span>We know that not everyone can afford to spend a lot of money on a smartwatch, so we've made sure to offer a variety of budget-friendly options. </span></p> <p><span>You can find feature-packed smartwatches that won't break the bank, so you can stay connected, track your fitness, and make a statement without spending a fortune.</span></p> <h3><strong>Advanced Bluetooth calling allows you to answer or make calls with a single tap</strong></h3> <p><span>With our Bluetooth calling feature, you can stay connected with your friends and family without having to take your phone out of your pocket. Simply tap on your smartwatch to answer or make a call, and you'll be able to talk to whoever you need to without missing a beat.</span></p> <h3><strong>Browse our wide selection of smartwatches and find the perfect one that suits your needs and budget</strong></h3> <p><span>We have a wide variety of smartwatches to choose from, so you're sure to find one that's perfect for you. Whether you're looking for a fitness tracker, a smartwatch with a long battery life, or a smartwatch with a stylish design, we have something for everyone.</span></p> <h3><strong>Stay connected, track your fitness, and make a statement</strong></h3> <p><span>With our smartwatches, you can do it all. Stay connected with your friends and family, track your fitness progress, and make a statement with your stylish smartwatch. So what are you waiting for? Elevate your wearable technology experience and shop now.</span></p>",
    //             "metaKeyWord": "bluetooth, amoled, bluetooth amoled smartwatches under 3000, smartwatches under 3000",
    //             "metaDescription": "Discover the best Bluetooth AMOLED smartwatches under Rs 3000. Stay connected and track your fitness with these affordable and feature-packed smartwatches. Shop now!",
    //             "urlKey": "amoled-bluetooth-calling-smartwatches-under-3000",
    //             "createdAt": 1688033856748,
    //             "desktopBanner": "https://img.beatxp.com/prod/categories/banner/smartwatch%20category%20banner_desktop.webp",
    //             "mobileBanner": "https://img.beatxp.com/prod/categories/banner/smartwatch%20category%20banner_desktop.webp",
    //             "desktopImage": "www.image.beatxp.com",
    //             "metaTitle": "Buy Best Bluetooth Amoled Smart watches Under Rs 3000",
    //             "name": "Amoled Bluetooth Calling Smartwatches Under 3000",
    //             "conditonList": [
    //                 {
    //                     "attributeCode": "price",
    //                     "subCatId": 1,
    //                     "id": 22,
    //                     "value": "3000",
    //                     "relation": "lte",
    //                     "products": [
    //                         304,
    //                         307,
    //                         325,
    //                         326,
    //                         327,
    //                         332,
    //                         333,
    //                         335,
    //                         336,
    //                         338,
    //                         345,
    //                         347,
    //                         348,
    //                         350,
    //                         351,
    //                         352,
    //                         354,
    //                         355,
    //                         357,
    //                         358,
    //                         372,
    //                         373,
    //                         374,
    //                         375,
    //                         377,
    //                         378,
    //                         379,
    //                         381,
    //                         382,
    //                         383,
    //                         385,
    //                         386,
    //                         387,
    //                         389,
    //                         390,
    //                         392,
    //                         393,
    //                         394,
    //                         396,
    //                         399
    //                     ]
    //                 },
    //                 {
    //                     "attributeCode": "sc_display",
    //                     "subCatId": 1,
    //                     "id": 23,
    //                     "value": "44",
    //                     "relation": "eq",
    //                     "products": [
    //                         332,
    //                         333,
    //                         338,
    //                         345,
    //                         347,
    //                         348,
    //                         357,
    //                         358,
    //                         374,
    //                         375,
    //                         377,
    //                         378,
    //                         379,
    //                         381,
    //                         396,
    //                         397,
    //                         398,
    //                         399,
    //                         400
    //                     ]
    //                 },
    //                 {
    //                     "attributeCode": "sc_feature",
    //                     "subCatId": 1,
    //                     "id": 24,
    //                     "value": "55",
    //                     "relation": "eq",
    //                     "products": [
    //                         304,
    //                         325,
    //                         326,
    //                         327,
    //                         332,
    //                         333,
    //                         335,
    //                         336,
    //                         338,
    //                         345,
    //                         347,
    //                         348,
    //                         350,
    //                         351,
    //                         352,
    //                         354,
    //                         355,
    //                         357,
    //                         358,
    //                         371,
    //                         372,
    //                         373,
    //                         374,
    //                         375,
    //                         377,
    //                         378,
    //                         379,
    //                         381,
    //                         382,
    //                         383,
    //                         384,
    //                         392,
    //                         393,
    //                         394,
    //                         395,
    //                         396,
    //                         397,
    //                         398,
    //                         399,
    //                         400
    //                     ]
    //                 }
    //             ],
    //             "thumbnailImage": "www.image.beatxp.com",
    //             "blogId": "793,1119,1082",
    //             "status": 1,
    //             "updatedAt": 1688033856748
    //         }
    //     ],
    //     "all_children": "",
    //     "meta_keywords": "beatxp, unbound, marv, exact, best smartwatch, best smartwatch in india, smartwatches, vega smartwatch, best affordable smartwatches",
    //     "isActive": "1",
    //     "path_in_store": "",
    //     "path": "static",
    //     "sync_to_facebook_catalog": "1",
    //     "children": "",
    //     "filter_price_range": "",
    //     "page_layout": "",
    //     "available_sort_by": "",
    //     "imageUrl": "/pub/media/catalog/category/Category_Banner.jpg",
    //     "id": "37",
    //     "special_category": "",
    //     "url_path": "smartwatches",
    //     "meta_title": "Buy Smartwatches Online Upto 85% Off - Men & Women Smartwatches",
    //     "level": "static",
    //     "landing_page": "",
    //     "custom_apply_to_products": "0",
    //     "custom_design_to": "",
    //     "urlKey": "smartwatches",
    //     "meta_description": "Check out these amazing smartwatches from beatXP, Marv, Unbound, Vega and Exact. Best affordable and budget smartwatches for men & women.",
    //     "custom_design_from": "",
    //     "name": "Smartwatches",
    //     "includeInMenu": "1",
    //     "default_sort_by": "",
    //     "position": "static",
    //     "custom_use_parent_settings": "0"
    // },
    // {
    //     "custom_layout_update_file": "",
    //     "is_anchor": "1",
    //     "display_mode": "PRODUCTS",
    //     "custom_layout_update": "",
    //     "children_count": "static",
    //     "extra_category_info": [
    //         {
    //             "id": 3,
    //             "categoryId": "42",
    //             "desktopImage": "https://img.beatxp.com/prod/categories/banner/protein%20banner%20desktop.webp",
    //             "mobileImage": "https://img.beatxp.com/prod/categories/banner/protein%20banner%20mobile.webp",
    //             "blogInfo": "839,856,810",
    //             "categoryThumbnail": "https://img.beatxp.com/prod/category/thumbnail/%2FSports%20Nutrition.webp"
    //         }
    //     ],
    //     "custom_design": "",
    //     "description": "",
    //     "sub_categories_list": [],
    //     "all_children": "",
    //     "meta_keywords": "",
    //     "isActive": "1",
    //     "path_in_store": "",
    //     "path": "static",
    //     "sync_to_facebook_catalog": "1",
    //     "children": "",
    //     "filter_price_range": "",
    //     "page_layout": "",
    //     "available_sort_by": "",
    //     "imageUrl": "/pub/media/catalog/category/Protein_Category_1.jpg",
    //     "id": "42",
    //     "special_category": "",
    //     "url_path": "sports-nutrition",
    //     "meta_title": "",
    //     "level": "static",
    //     "landing_page": "",
    //     "custom_apply_to_products": "0",
    //     "custom_design_to": "",
    //     "urlKey": "sports-nutrition",
    //     "meta_description": "",
    //     "custom_design_from": "",
    //     "name": "Sports Nutrition",
    //     "includeInMenu": "1",
    //     "default_sort_by": "",
    //     "position": "static",
    //     "custom_use_parent_settings": "0"
    // },
    // {
    //     "custom_layout_update_file": "",
    //     "is_anchor": "1",
    //     "display_mode": "PRODUCTS",
    //     "custom_layout_update": "",
    //     "children_count": "static",
    //     "extra_category_info": [],
    //     "custom_design": "",
    //     "description": "",
    //     "sub_categories_list": [],
    //     "all_children": "",
    //     "meta_keywords": "",
    //     "isActive": "0",
    //     "path_in_store": "",
    //     "path": "static",
    //     "sync_to_facebook_catalog": "0",
    //     "children": "",
    //     "filter_price_range": "",
    //     "page_layout": "",
    //     "available_sort_by": "",
    //     "imageUrl": "",
    //     "id": "46",
    //     "special_category": "",
    //     "url_path": "wireless-earbuds",
    //     "meta_title": "",
    //     "level": "static",
    //     "landing_page": "",
    //     "custom_apply_to_products": "0",
    //     "custom_design_to": "",
    //     "urlKey": "wireless-earbuds",
    //     "meta_description": "",
    //     "custom_design_from": "",
    //     "name": "Wireless Earbuds",
    //     "includeInMenu": "0",
    //     "default_sort_by": "",
    //     "position": "static",
    //     "custom_use_parent_settings": "0"
    // }
]

export const complaintTypeOptions = [
    { label: 'Product not working', value: 'product_quality' },
    { label: 'Incomplete Exercise bike/ Installation/ Repair Request', value: 'air_bike_installation' },
    { label: 'Delivery', value: 'delivery' },
];
export const genderOptions = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Others', value: 'others'}
];
export const complaintTypeOptions2 = [
    { label: 'Delivery', value: 'delivery' },
    { label: 'Some item(s) missing from my order', value: 'items_missing' }, //delivery-1
    { label: 'Used items received', value: 'poor_quality' }, //delivery-2
    { label: 'Wrong item(s) / Order received', value: 'wrong_items' }, //delivery-3
    { label: 'General Query', value: 'general_query' },
    { label: 'Product not working', value: 'product_quality' },
    { label: 'Incomplete Exercise bike/ Installation/ Repair Request', value: 'air_bike_installation' },
    { label: 'Order Related', value: 'orders_related' },
    { label: 'Others', value: 'others' }
];

export const subDeliveryOptions = [
    { label: 'Some item(s) missing from my order', value: 'items_missing' },
    { label: 'Used items received', value: 'poor_quality' },
    { label: 'Wrong item(s) / Order received', value: 'wrong_items' },
]

export const channelList = [{ "label": "BeatXP Website", "value": "BeatXP Website" }, { "label": "Amazon", "value": "Amazon" }, { "label": "Flipkart", "value": "Flipkart" }, { "label": "1 MG", "value": "1 MG" }, { "label": "Jio Mart", "value": "Jio Mart" }, { "label": "Snapdeal", "value": "Snapdeal" }, { "label": "Netmeds", "value": "Netmeds" }, { "label": "Meesho", "value": "Meesho" }, { "label": "Moblix", "value": "Moblix" }, { "label": "Nyka", "value": "Nyka" }, { "label": "Tata Cliq", "value": "Tata Cliq" }, { "label": "Shopclues", "value": "Shopclues" }, { "label": "Pharmeasy", "value": "Pharmeasy" }, { "label": "Myntra", "value": "Myntra" }, { "label": "Cred", "value": "Cred" }, { "label": "Blinkit", "value": "Blinkit" }, { "label": "B2B", "value": "B2B" }, { "label": "Others", "value": "Others" }]

// , { label: "Replacement Orders", value: "replacement_orders"}